import React from 'react';
import { VariantProps, cva } from 'class-variance-authority';
import { cn } from '~/helpers/utils';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const messageVariants = cva(
  'border p-4 rounded',
  {
    variants: {
      variant: {
        default: 'bg-stone-50 border-stone-300',
        info: 'bg-blue-50 border-blue-300',
        error: 'bg-red-50 border-red-300',
        success: 'bg-green-50 border-green-300',
        checked: 'bg-blue-25 border-blue-400',
        active: 'bg-blue-50 border-blue-300',
        inactive: 'bg-tomato-50 border-tomato-400',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

interface MessageProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof messageVariants> {
  type?: 'info' | 'alert' | 'success' | 'active' | 'inactive';
  icon?: IconProp;
}

const Message = React.forwardRef<HTMLDivElement, MessageProps>(
  ({ icon, type, variant, className, children, ...props }, ref) => {
    return (
      <div
        className={cn(messageVariants({ variant }), className)}
        {...props}
      >
        {icon && (
          <FontAwesomeIcon icon={icon} className={cn(
            'text-blue-600 mr-3',
            type === 'info' ? 'text-blue-600' : '',
            type === 'alert' ? 'text-red-50' : '',
            type === 'success' ? 'text-green-500' : '',
            type === 'active' ? 'text-stone-400 text-2xl' : '',
            type === 'inactive' ? 'text-tomato-500 text-2xl' : '',
          )} />
        )}
        {children}
      </div>
    );
  }
);

Message.displayName = "Message";

export { Message, messageVariants };